var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"license"},[_c('a',{attrs:{"href":"https://creativecommons.org/licenses/by-nc-nd/3.0/es/deed.en"}},[_vm._v("\n    Creative Commons license (CC BY-NC-ND 3.0 ES)\n  ")]),_vm._v(" "),_c('license-icons')],1)}
var staticRenderFns = []

export { render, staticRenderFns }